/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "account/statements";

export const STATEMENTS_PATHS = {
  BASE,
} as const;

export const STATEMENTS_ROUTES = {
  BASE: `/${STATEMENTS_PATHS.BASE}`,
  ROOT: `/${STATEMENTS_PATHS.BASE}/*`,
  NAME: "Statements",
} as const;
